import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/about-us/components/banner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/about-us/components/Herosection.jsx");
